import { gql, useMutation } from '@apollo/client';

import {
  SessionIntentionNotificationCadence,
  SessionIntentionNotificationTimeOfDay,
} from '@grow-therapy-team/seedling-components';

import { Server } from '../../apollo/types';
import { SessionIntention__CreatedBy, SessionIntention__EditedBy } from './types';

interface SessionIntention {
  shortId: string;
  appointmentShortId: string;
  clientUserShortId: string;
  providerShortId: string;
  contentText: string;
  contentImageUrl: string | null;
  notificationCadence: SessionIntentionNotificationCadence | null;
  notificationTimeOfDay: SessionIntentionNotificationTimeOfDay | null;
  expiredAt: string | null;
  createdBy: SessionIntention__CreatedBy;
  editedBy: SessionIntention__EditedBy | null;
}

interface CreateSessionIntentionData {
  createSessionIntention: {
    sessionIntention: SessionIntention;
  };
}

interface CreateSessionIntentionVariables {
  clientUserShortId: string;
  appointmentShortId: string;
  contentText: string;
  notificationCadence?: SessionIntentionNotificationCadence;
  notificationTimeOfDay?: SessionIntentionNotificationTimeOfDay;
}

const createSessionIntentionDocument = gql`
  mutation CreateSessionIntention(
    $clientUserShortId: String!
    $appointmentShortId: String!
    $contentText: String!
    $notificationCadence: SessionIntentionNotificationCadence
    $notificationTimeOfDay: SessionIntentionNotificationTimeOfDay
  ) {
    createSessionIntention(
      clientUserShortId: $clientUserShortId
      appointmentShortId: $appointmentShortId
      contentText: $contentText
      notificationCadence: $notificationCadence
      notificationTimeOfDay: $notificationTimeOfDay
    ) {
      sessionIntention {
        shortId
        appointmentShortId
        clientUserShortId
        providerShortId
        contentText
        contentImageUrl
        notificationCadence
        notificationTimeOfDay
        expiredAt
        createdBy
        editedBy
      }
    }
  }
`;

export function useCreateSessionIntentionMutation() {
  return useMutation<CreateSessionIntentionData, CreateSessionIntentionVariables>(createSessionIntentionDocument, {
    context: {
      server: Server.MONOLITH,
    },
  });
}
